
const organizationsTypes = {
  ORGANIZATION_SET: 'ORGANIZATION_SET',
  ORGANIZATIONS_LIST_SET: 'ORGANIZATIONS_LIST_SET',
  SET_ORGANIZATION_CONGRATS: 'SET_ORGANIZATION_CONGRATS',
  ORGANIZATION_MUTATE_BASE_CURRENCY_ABILITIES: 'ORGANIZATION_MUTATE_BASE_CURRENCY_ABILITIES'
};
export default organizationsTypes;